import React from 'react';
import {connect} from "react-redux"
import NotificationsSystem from 'reapop';
import reapopTheme from 'reapop-theme-wybo';
import { push } from 'react-router-redux';

import LoginForm from "../components/forms/LoginForm";
import CardText from "react-toolbox/lib/card/CardText";
import Card from "react-toolbox/lib/card/Card";
import * as routes from "../constants/routes";
import * as authHandler from "../utils/authHandler";

class Login extends React.Component {
    constructor(props) {
        super(props);

        if (authHandler.isLoggedIn()) {
            this.props.dispatch(push(routes.HOME));
        }
    }

    render() {
        if (this.props.loading) {
            return (<div>Loading</div>)
        }

        return (
            <div className="flex-full-wrapper login-page">
                <NotificationsSystem theme={reapopTheme} />
                <div className="top-left-logo"><img src="/images/brand.png" alt="Intertek" /></div>
                <div className="centered-box">
                    <Card
                        style={{width: '350px'}}>
                        <CardText>
                            <LoginForm {...this.props} connecting={this.props.connecting} errors={this.props.errors} />
                        </CardText>
                    </Card>
                </div>
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        user: state.user,
        connecting: state.connect.loading,
        errors: state.connect.errors,
    });
})(Login);



// WEBPACK FOOTER //
// ./src/containers/Login.js